import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../shared/styles/CardArticleForm.css";

import "../../shared/styles/HomeDefault.css";



import { Container, Nav, Navbar, NavDropdown, Form, Button, Image, Carousel, Row, Col, Card, Tabs, Tab, Spinner, Badge } from 'react-bootstrap'

/* import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from "@fortawesome/free-solid-svg-icons"; */


/* 
import { firestore } from '../../database/firebase';
import { auth } from '../../database/firebase';
import { AuthContext } from '../Old_Test/Auth'; */

import { Link, Navigate } from "react-router-dom";

import { FaHeart, FaTruck, FaFacebookMessenger } from "react-icons/fa";
import NewestArticle from '../../features/home/components/NewestArticle';
// import { BsStarFill, BsStarHalf, BsStar, BsBagHeart } from "react-icons/bs";


import Test_Ads_03 from "../../assets/Test_Ads_03.png";
import Test_Ads_04 from "../../assets/Test_Ads_04.png";
import Test_Ads_05 from "../../assets/Test_Ads_05.png";

import Ads_Encraft_06 from "../../assets/Ads_Encraft_06.png";
import Ads_Encraft_07 from "../../assets/Ads_Encraft_07.png";
import Ads_Encraft_08 from "../../assets/Ads_Encraft_08.png";


import BrowseCategory from '../../features/home/components/BrowseCategory';
// import CardsLayout from '../../features/home/components/CardsLayout';
import RecommendedArticleListWideSection from '../../features/home/components/RecommendedArticleListWideSection';
import UpdateArticle from '../../features/home/components/UpdateArticle';
import LoginPromptSection from '../../features/home/components/LoginPromptSection';


function HomeDefault() {
    

    return (
        
        <div>

            {/* <Container> */}
               {/*  <img
                    className="d-block w-100"
                    src={Test_Ads_05}
                    alt="Second slide"
                    style={{borderRadius: 10}}
                /> */}
                

             {/*    <br/>
            </Container> */}

            <Container>
                    <UpdateArticle/>
                    <br/>
                   {/*  <LoginPromptSection/>
                    <br/> */}
                     {/* Hero EnChat + ปุ่ม CTA */}
                    <div className="enchat-hero-wrapper">
                        <img
                        className="d-block w-100 enchat-hero-image"
                        src={Ads_Encraft_08}
                        alt="EnChat Hero"
                        style={{ borderRadius: 10 }}
                        />

                        {/* ปุ่มอ่านรายละเอียด EnChat */}
                        <div className="enchat-hero-cta-wrapper">
                        <Link to="/enchat">
                            <button type="button" className="btn enchat-hero-cta">
                            อ่านรายละเอียด EnChat
                            </button>
                        </Link>
                        </div>
                    </div>
                    <br/>
                    <BrowseCategory/>
            </Container>

             <br/>
            <Container className="pt-4 pb-5">
                <RecommendedArticleListWideSection/>
            </Container>
                

        
        </div>

  );
}

export default HomeDefault;